import React, { useContext } from "react";
import { Dialog, DialogType } from "@fluentui/react/lib/Dialog";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";

import CustomEditor from "../../../Report/components/CustomEditorSection/CustomEditor";
import AlertSubmitSection from "../../../Report/components/RaiseAlertSection/AlertSubmitSection";
import LockWarning from "../../../Report/components/LockWarning/LockWarning";
import RadioDropdownSection from "../../../Report/components/RadioDropdownSection/RadioDropdownSection";
import AddTab from "../../../Report/components/AddTab/AddTab";
import NewReport from "../../../Report/NewReport"; 
import { isMobile } from "react-device-detect";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";

import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import "./MobileReportOverlay.css";
const MobileReportOverlay = ({ isOpen, onClose, readOnly, modality, patientId }) => {
  const {
    allReportTemplatesLoading,
    studyParentId,
    extReportRecieved,
    parentChildReportsObj,
    showStudyExpirationPopup,
    showStudyAlreadyExpiredPopup,
  } = useContext(studyReportContext);
  const {
    annotationData,
    allTextToolAnnotation,
    activeViewportIndex,
  } = useContext(ViewportContext);
  const {
    keyImages,
    setConfirmAlertModal,
    assignmentData,
    annotationDataAI,
    fetchStudyData,
    generateStudytData,
    studyData,
    studyResponseData,
    studyModality,
    showToast,
    savedKeyImages,
   
    
    setStudyData,
    progress,
    dataGathered,
    setDataGathered,
    thumbnailLoaded,
    setThumbnailLoaded,
    qcData,
  } = useContext(studyviewerContext);
  // ✅ TEMPORARY: bypass loading spinner
  // if (allReportTemplatesLoading) {
  if (false && allReportTemplatesLoading) {
    return (
      <div className="mobile-report-loading">
        <Spinner size={SpinnerSize.large} label="Loading report..." />
      </div>
    );
  }
  if (!isOpen) return null;
  return (
    <div className={"mobile-report-overlay-wrapper"}>
      <div className={`mobile-report-overlay sidebar-open-left`}>
        <div className="mobile-report-container" style={{position: "relative"}}>
        <div className="mobile-lock-warning-section">
          <LockWarning />
        </div>
          {/* <RadioDropdownSection /> */}
          <div className="mobile-table-report">
            <AddTab />
          </div>
          {/* Report Editor */}
          <div className="new-editor-wrapper">
          <CustomEditor
            readOnly={readOnly}
            modality={modality}
            patientId={patientId}
            isStudyList={false}
            parentChildReportsObj={parentChildReportsObj}
            activeStudyId={null}
            studyParentId={studyParentId}
            extReportReived={extReportRecieved}
            showStudyExpirationPopup={showStudyExpirationPopup}
            showStudyAlreadyExpiredPopup={showStudyAlreadyExpiredPopup}
          />
          </div>  
        </div>  
          {/* {!readOnly && <AlertSubmitSection />} */}
          <div className="mobile-download-section">
          <AlertSubmitSection
            readOnly={readOnly}
            isStudyList={false}
            modality={modality}
            keyImages={keyImages}
            annotationData={annotationData}
            annotationDataAI={annotationDataAI}
            allTextToolAnnotation={allTextToolAnnotation}
            activeViewportIndex={activeViewportIndex}
            studyParentId={studyParentId}
            patientId={patientId}
            extReportReived={extReportRecieved}
          />
     </div>
  </div>
  </div>
  );
};

export default MobileReportOverlay;
